import { DetailRequirement, TraitId } from '@cibo/core'
import { useProgramEngagementContext } from '../context'

export const useEditorFieldOmissions = (detailRequirement: DetailRequirement) => {
  const { taskEditorParams } = useProgramEngagementContext()

  const schema = taskEditorParams?.editorSchemas?.find(
    (s: { traitId: TraitId }) => s.traitId === detailRequirement.traitId
  )?.schema

  return {
    shouldOmit: (fieldName: string) => {
      if (!schema) return false
      return !schema.properties?.[fieldName]
    },
  }
}
